import Column from "./Column";
import PropTypes from "prop-types";
import React from "react";

export default class Header extends React.Component {
    render() {
        const { columns, sorts, onSort, fixedHeaders } = this.props;

        return columns.map((column) =>
            <Column
                onSort={onSort}
                fixedHeaders={fixedHeaders}
                key={column.key}
                sorts={sorts}
                column={column}
                name={column.name}
            />
        );
    }
}

Header.propTypes = {
    columns: PropTypes.array.isRequired,
    fixedHeaders: PropTypes.bool,
    sorts: PropTypes.object.isRequired,
    onSort: PropTypes.func
};

Header.defaultProps = {
    fixedHeaders: false
};



// WEBPACK FOOTER //
// ./app/lib/common/selectiontable/lib/header/Header.js